import { ValueOf } from './util';

export const bulkGrantAggregationCriterias = {
  DAILY: '日次',
  MONTHLY: '月次',
  YEARLY: '年次',
  WALLET_SERVICE: 'ウォレットサービス別',
  BULK_GRANT: '管理名称',
} as const;

export type BulkGrantAggregationCriteriaKey = keyof typeof bulkGrantAggregationCriterias;
export type BulkGrantAggregationCriteriaValue = ValueOf<typeof bulkGrantAggregationCriterias>;

export const bulkGrantAggregationCriteriaKeys = Object
  .keys(bulkGrantAggregationCriterias) as BulkGrantAggregationCriteriaKey[];

/** v-select用items */
export const bulkGrantAggregationCriteriaItems = bulkGrantAggregationCriteriaKeys
  .map((key) => ({
    title: bulkGrantAggregationCriterias[key],
    value: key,
  }));
